import React from 'react';
import AppRouter from './routes/AppRouter';

function App() {
  return (
    <div className="App antialiased">
      <AppRouter />
    </div>
  );
}

export default App;